<script>
  import * as XLSX from 'xlsx';
  import { onMount } from 'svelte';
  import { API_BASE_URL } from '../components/lib/config.js';
  let orderRows = [];         //한 열을 받아오는 JOSON을 저장  
  let error = '';             //에러 메시지 문자열
  let selectedRow = null;
  let selectedIndex = null; // 번호 저장용

  let errorMessage = "";
  let filteredRows = []; // 조건에 맞는 결과 저장
  let searchMode = 'item'; // 기본값: 항목별 조회
  

  // 체크박스 상태
  let useItemSearch = false;
  let useDateSearch = false;

  //항목별 조회 
  let selectedItemField = '';
  let searchInput = '';
  
  //날짜별 조회
  let selectedDateField = '';
  let startDate = '';
  let endDate = '';

  // 조회 실행
  // 변경된 performSearch 함수
  function performSearch() {
    errorMessage = "";

    if (!useItemSearch && !useDateSearch) {
      errorMessage = "조회 조건을 하나 이상 선택해주세요.";
      filteredRows = [];
      return;
    }
    
    const searchConditions = {};

    // 항목별 조회 조건
    if (useItemSearch) {
      if (!selectedItemField || !searchInput.trim()) {
        errorMessage = "항목별 조회 조건을 모두 입력해주세요.";
        filteredRows = [];
        return;
      }
      const fieldMap = {
        client: 'client_name',
        project: 'project_name',
        part: 'part_no',
        order: 'order_no',
        partno: 'part_no',
        machining: 'process_id',
        addon: 'add_process_id',
        postprocess: 'post_process_id'
      };
      // 백엔드가 인식할 수 있도록 필드명(key)과 검색어(value)를 직접 추가
      searchConditions[fieldMap[selectedItemField]] = searchInput.trim();
    }

    // 날짜별 조회 조건
    if (useDateSearch) {
      if (!selectedDateField || !startDate || !endDate) {
        errorMessage = "날짜별 조회 조건을 모두 선택해주세요.";
        filteredRows = [];
        return;
      }
      // 백엔드가 인식할 수 있도록 날짜 필드와 범위를 하나의 키로 추가
      searchConditions.dateField = selectedDateField;
      searchConditions.startDate = startDate;
      searchConditions.endDate = endDate;
    }

    // loadOrders 함수 호출 시 검색 조건을 전달
    loadOrders(searchConditions);
  }


  function openDetail(row, index) {
    selectedRow = row;
    selectedIndex = index;
  }
  function closeDetail() {
    selectedRow = null;
  }

  async function deleteFilteredOrders() {
    if (!filteredRows || filteredRows.length === 0) {
      alert("삭제할 데이터가 없습니다.");
      return;
    }

    if (!confirm("조회된 모든 내용을 삭제하시겠습니까?")) return;

    try {
      const ids = filteredRows.map(r => r.id);
      const res = await fetch(`${API_BASE_URL}/api/orders/delete/bulk`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ids })
      });

      if (!res.ok) throw new Error("삭제 실패");

      alert("삭제가 완료되었습니다.");
      await loadOrders(); // 새로 불러오기
    } catch (err) {
      console.error(err);
      alert("삭제 중 오류 발생");
    }
  }

  async function deleteSingleOrder(id) {
    if (!confirm("현재 조회된 항목을 삭제하시겠습니까?")) return;

    try {
      const res = await fetch(`${API_BASE_URL}/api/orders/${id}`, {
        method: "DELETE"
      });

      if (!res.ok) throw new Error("삭제 실패");

      alert("삭제가 완료되었습니다.");
      closeDetail();
      await loadOrders();
    } catch (err) {
      console.error(err);
      alert("삭제 중 오류 발생");
    }
  }

  //-------------화면 출력용-------------//
  function formatDate(dateString) {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleDateString('ko-KR');
  }

  /**
   * DB에서 가져온 시간을 KST(한국 표준시)로 포맷합니다.
   * 기존 코드는 이미 로컬 타임존으로 해석된 Date 객체에 9시간을 또 더하는 오류가 있었습니다.
   * 이 로직을 제거하여 올바른 시간을 표시하도록 수정했습니다.
   * 또한, 문자열 템플릿 문법 오류를 수정했습니다.
   */
  function formatTimeToKST(isoString) {
    if (!isoString) return '-';
    const date = new Date(isoString);
    // 기존의 `date.getTime() + offsetKST` 부분을 제거했습니다.
    // Date 객체는 클라이언트의 로컬 시간을 기준으로 생성되므로, 별도로 9시간을 더할 필요가 없습니다.

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const hh = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const ss = String(date.getSeconds()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
  }


  function exportToExcel() {
    if (!filteredRows || filteredRows.length === 0) {
      errorMessage = "저장할 데이터가 없습니다.";
      return;
    }

    const headerMap = {
      id: 'id',
      order_date: '오더날짜',
      client_name: '발주처',
      project_name: '사업명',
      part_no: '품목',
      order_no: '오더넘버',
      quantity: '수량',
      due_date: '납기예정일',
      remarks: '비고',
      material_ready: '자재준비종료',
      process_start: '가공시작',
      process_end: '가공종료',
      process_id: '가공장치번호',
      add_process_start: '추가가공시작',
      add_process_end: '추가가공종료',
      add_process_id: '추가가공장치번호',
      post_process_start: '후처리 시작',
      post_process_end: '후처리종료',
      post_process_id: '후처리장치번호',
      inspection_end: '검사종료',
      other_process: '추가공정',
      shipment: '출하'
    };

    const formattedRows = filteredRows.map(row => {
      const newRow = {};

      Object.entries(row).forEach(([key, val]) => {
        const displayKey = headerMap[key] || key;
        let displayVal = val;

        if (['due_date', 'order_date'].includes(key)) {
          displayVal = formatDate(val);
        } else if (
          ['material_ready','process_start','process_end',
          'add_process_start','add_process_end',
          'post_process_start','post_process_end',
          'inspection_end','other_process','shipment'].includes(key)
        ) {
          displayVal = formatTimeToKST(val);
        }

        newRow[displayKey] = displayVal;
      });

      return newRow;
    });

    const worksheet = XLSX.utils.json_to_sheet(formattedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Orders');

    const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([wbout], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Orders.xlsx';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    }, 100);
  }

  // 변경된 loadOrders 함수
  async function loadOrders(searchConditions = {}) { // 기본값으로 빈 객체 설정
    error = '';
    try {
      const url = new URL(`${API_BASE_URL}/api/orders`);
      
      // searchConditions 객체의 키-값 쌍을 URL 쿼리 매개변수로 추가
      for (const key in searchConditions) {
          url.searchParams.append(key, searchConditions[key]);
      }

      const res = await fetch(url.toString(), { cache: 'no-store' });
      if (!res.ok) throw new Error('네트워크 응답 오류');
      
      orderRows = await res.json();
      filteredRows = [...orderRows];
      
    } catch (err) {
      error = '데이터를 불러오는 데 실패했습니다.';
      console.error(err);
    }
  }

  // onMount에서는 loadOrders()를 조건 없이 호출하여 전체 데이터를 가져옴
  // onMount(async () => {
  //   loadOrders();
  // });



  async function handleAction(order_no, field, action) {
    const url = `${API_BASE_URL}/api/order-status/${action === 'OK' ? 'update-field' : 'delete-field'}`;

    try {
      const res = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ order_no, field })
      });

      const data = await res.json();
      if (!res.ok) {
        alert("실패: " + data.message);
        return;
      }

      //alert(data.message);

      // ✅ 전체 테이블 갱신
      await loadOrders();

      // ✅ 1초 딜레이 후 선택한 row를 다시 열기
      setTimeout(() => {
        const updatedRow = orderRows.find(r => r.order_no === order_no);
        if (updatedRow) {
          selectedRow = { ...updatedRow };
          selectedIndex = orderRows.indexOf(updatedRow);
        }
      }, 500); // 1초 후
    } catch (err) {
      console.error("에러 발생:", err);
      alert("에러 발생");
    }
  }







  // onMount(async () => {
  //    loadOrders();
  // });
</script>


<main>
  {#if error}
    <p>{error}</p>
  {:else}

  <div class="search-container">
    <div style="display: flex; gap: 12px;">
      <div class="search-card">
        <label>
          <input type="checkbox" bind:checked={useItemSearch} />
          항목별 조회
        </label>
        <div>
          <select bind:value={selectedItemField} disabled={!useItemSearch}>
            <option value="">항목 선택</option>
            <option value="client">발주처</option>
            <option value="project">사업명</option>
            <option value="part">품목</option>
            <option value="order">오더넘버</option>
            <option value="partno">파트넘버</option>
            <option value="machining">가공장치</option>
            <option value="addon">추가가공장치</option>
            <option value="postprocess">후처리가공장치</option>
          </select>
        </div>
        <div>
          <input type="text" bind:value={searchInput} placeholder="검색어 입력" disabled={!useItemSearch} />
        </div>
      </div>

      <div class="search-card">
        <label>
          <input type="checkbox" bind:checked={useDateSearch} />
          날짜별 조회
        </label>
        <div>
          <select bind:value={selectedDateField} disabled={!useDateSearch}>
            <option value="">날짜 항목 선택</option>
            <option value="order_date">오더날짜</option>
            <option value="due_date">납기예정</option>
            <option value="process_start">가공시작</option>
            <option value="process_end">가공종료</option>
            <option value="post_process_start">후처리시작</option>
            <option value="post_process_end">후처리종료</option>
            <option value="inspection_end">검사종료</option>
            <option value="shipment">출하</option>
            <option value="material_ready">자재준비</option>
          </select>
        </div>
        
        <div class="date-input-group">
          <label>시작날짜</label>
          <input type="date" bind:value={startDate} disabled={!useDateSearch} />
        </div>

        <div class="date-input-group">
          <label>종료날짜</label>
          <input type="date" bind:value={endDate} disabled={!useDateSearch} />
        </div>
      </div>

    </div>

    <div class="button-group">
      <button on:click={performSearch}><i class="bi bi-search"></i> 조회</button>
      <button on:click={deleteFilteredOrders}><i class="bi bi-trash"></i> 삭제</button>
      <button on:click={exportToExcel}><i class="bi bi-filetype-xlsx"></i> 엑셀 저장</button>
    </div>
  </div>

   
  {#if errorMessage}
    <div class="error-message">{errorMessage}</div>
  {/if}
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th>번호</th>
          <th>오더날짜</th>
          <th>발주처</th>
          <th>사업명</th>
          <th>품목</th>
          <th>오더넘버</th>
          <th>수량</th>          
          <th>납기일</th>
          <th>자재준비</th>
          <th>가공시작</th>
          <th>가공종료</th>
          <th>가공장치</th>
          <th>추가가공시작</th>
          <th>추가가공종료</th>
          <th>추가가공장치</th>
          <th>후처리시작</th>
          <th>후처리종료</th>
          <th>후처리장치</th>
          <th>검사종료</th>
          <th>추가공정</th>
          <th>출하</th>
        </tr>
      </thead>
      <tbody>
        <!-- {#each orderRows as row} -->
        {#each filteredRows as row, i}
          <!-- <tr on:click={() => openDetail(row)}> -->
            <!-- <tr on:click={() => openDetail(row, i + 1)}> -->
            <tr on:dblclick={() => openDetail(row, i + 1)}>
             
            <!-- <td>{row.id}</td> -->
            <td>{i + 1}</td>
            <td>{formatDate(row.order_date)}</td>
            <td>{row.client_name}</td>
            <td>{row.project_name}</td>
            <td>{row.part_no}</td>
            <td>{row.order_no}</td>
            <td>{row.quantity}</td>
            <td>{formatDate(row.due_date)}</td>
            <td>{formatTimeToKST(row.material_ready)}</td>
            <td>{formatTimeToKST(row.process_start)}</td>
            <td>{formatTimeToKST(row.process_end)}</td>
            <td>{row.process_id}</td>
            <td>{formatTimeToKST(row.add_process_start)}</td>
            <td>{formatTimeToKST(row.add_process_end)}</td>
            <td>{row.add_process_id}</td>
            <td>{formatTimeToKST(row.post_process_start)}</td>
            <td>{formatTimeToKST(row.post_process_end)}</td>
            <td>{row.post_process_id}</td>
            <td>{formatTimeToKST(row.inspection_end)}</td>
            <td>{formatTimeToKST(row.other_process)}</td>
            <td>{formatTimeToKST(row.shipment)}</td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>  
  {/if}

  {#if selectedRow}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="dialog-backdrop" on:click={closeDetail}>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <div class="dialog-content" on:click|stopPropagation>
        <!-- <h3>상세 정보 - NO {selectedRow.id}</h3> -->
         <h3>상세 정보 - NO {selectedIndex}</h3>
        <table>
          <tr><td><strong>오더날짜</strong></td><td>{formatDate(selectedRow.order_date)}</td> <td></td><td></td> </tr>
          <tr><td><strong>발주처</strong></td><td>{selectedRow.client_name}</td> <td></td><td></td> </tr>
          <tr><td><strong>사업명</strong></td><td>{selectedRow.project_name}</td> <td></td><td></td> </tr>
          <tr><td><strong>품목</strong></td><td>{selectedRow.part_no}</td> <td></td><td></td> </tr>
          <tr><td><strong>오더넘버</strong></td><td>{selectedRow.order_no}</td> <td></td><td></td> </tr>
          <tr><td><strong>전체수량</strong></td><td>{selectedRow.quantity}</td> <td></td><td></td> </tr>          
          <tr><td><strong>납기일</strong></td><td>{formatDate(selectedRow.due_date)}</td> <td></td><td></td> </tr>
          <tr><td><strong>자재준비</strong></td><td>{formatTimeToKST(selectedRow.material_ready)}</td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "material_ready", "OK")}>OK</button></td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "material_ready", "DEL")}>DEL</button></td>
          </tr>
          <tr><td><strong>가공시작</strong></td><td>{formatTimeToKST(selectedRow.process_start)}</td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "process_start", "OK")}>OK</button></td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "process_start", "DEL")}>DEL</button></td>
          </tr>
          <tr><td><strong>가공종료</strong></td><td>{formatTimeToKST(selectedRow.process_end)}</td>
            
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "process_end", "OK")}>OK</button></td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "process_end", "DEL")}>DEL</button></td>
          </tr>
          <tr><td><strong>가공장치</strong></td><td>{selectedRow.process_id}</td> <td></td><td></td> </tr>
          <tr><td><strong>추가가공시작</strong></td><td>{formatTimeToKST(selectedRow.add_process_start)}</td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "add_process_start", "OK")}>OK</button></td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "add_process_start", "DEL")}>DEL</button></td>
          </tr>
          <tr><td><strong>추가가공종료</strong></td><td>{formatTimeToKST(selectedRow.add_process_end)}</td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "add_process_end", "OK")}>OK</button></td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "add_process_end", "DEL")}>DEL</button></td>
          </tr>
          <tr><td><strong>추가가공장치</strong></td><td>{selectedRow.add_process_id}</td> <td></td><td></td> </tr>
          <tr><td><strong>후처리시작</strong></td><td>{formatTimeToKST(selectedRow.post_process_start)}</td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "post_process_start", "OK")}>OK</button></td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "post_process_start", "DEL")}>DEL</button></td>
          </tr>
          <tr><td><strong>후처리종료</strong></td><td>{formatTimeToKST(selectedRow.post_process_end)}</td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "post_process_end", "OK")}>OK</button></td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "post_process_end", "DEL")}>DEL</button></td>
          </tr>
          <tr><td><strong>후처리가공장치</strong></td><td>{selectedRow.post_process_id}</td> <td></td><td></td> </tr>
          <tr><td><strong>검사종료</strong></td><td>{formatTimeToKST(selectedRow.inspection_end)}</td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "inspection_end", "OK")}>OK</button></td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "inspection_end", "DEL")}>DEL</button></td>
          </tr>
          <tr><td><strong>추가공정</strong></td><td>{formatTimeToKST(selectedRow.other_process)}</td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "other_process", "OK")}>OK</button></td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "other_process", "DEL")}>DEL</button></td>
          </tr>
          <tr><td><strong>출하</strong></td><td>{formatTimeToKST(selectedRow.shipment)}</td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "shipment", "OK")}>OK</button></td>
            <td><button class="small-btn" on:click={() => handleAction(selectedRow.order_no, "shipment", "DEL")}>DEL</button></td>
          </tr>
          <tr><td><strong>메모</strong></td><td>{selectedRow.remarks}</td> <td></td><td></td> </tr>
        </table>
        <button on:click={() => deleteSingleOrder(selectedRow.id)}>삭제</button>
        <button on:click={closeDetail}>닫기</button>
      </div>
    </div>
  {/if}
</main>




<style>
  main {
    margin: 0;
    padding: 6px;
    overflow-x: auto;
    font-family: 'Segoe UI', sans-serif;
  }

  button {
    padding: 8px 16px;
    font-size: 13px;
    min-width: 90px;
    background-color: #b6b69e;
    color: #fff;
    border: none;
    border-radius: 6px;
    cursor: pointer;
  }
  button:hover {
    background-color: #92927b;
  }

  
  /* 수정된 검색 영역 스타일*/
  .search-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    background-color: #f9f9f5;
    border: 1px solid #ddd;
    margin-bottom: 12px;
  }

  .search-container > div:first-child {
    display: flex; /* Flexbox를 사용하여 내부 요소들을 한 줄에 정렬 */
    flex-wrap: wrap; /* 창이 좁아질 때 줄바꿈 허용 */
    gap: 8px; /* 카드 사이 간격 축소 */
  }

  .search-card {
    border: 1px solid #ccc;
    padding: 8px;
    flex: 1;
    background: #f9f9f9;
    min-width: 240px;
    /* 추가: 내부 요소들을 세로로 정렬하고 간격을 조정합니다. */
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  /* 입력 요소 (select, input)의 스타일 조정 */
  select, input[type="text"], input[type="date"] {
    font-size: 13px; /* 폰트 크기 축소 */  
    height: 28px; /*추가: 높이를 고정하여 균일하게 만듭니다.*/
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100%; /* 변경: 부모 컨테이너에 꽉 차도록 설정합니다. /
    box-sizing: border-box; /* 패딩과 보더가 너비에 포함되도록 설정 */  
    margin-bottom: 2px; /* ✅ 기본 여백 최소화 */

  }

  /* 콤보박스(select)에만 별도의 패딩 적용 */
  select {
    height:30px;  
    padding-top: 0px;
    padding-bottom: 0px;
    padding-left: 20px; /* 콤보박스 항목 선택을 위해 패딩 적용 */
  }

  /* 날짜 입력 필드 그룹 간의 간격 조정 */
  .date-input-group {
    display: flex;
    align-items: center;
    gap: 0px;  
    font-size: 13px;

  }
  /*추가: 날짜 입력 필드 라벨의 너비를 고정하여 두 줄로 표시되는 문제를 해결합니다.*/
  .date-input-group label {
    white-space: nowrap; /* 텍스트가 줄바꿈되지 않도록 설정 */
    width: 70px; /* 고정된 너비 설정 */
    margin-bottom: 0px;
    padding: 0; /* ✅ 라벨 여백 제거 */
    align-items: flex-start; /* ✅ 수직 상단 정렬 */

  }

  /* 버튼 그룹의 스타일 조정 */
  .button-group {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  /* 에러 메시지 스타일 */
  .error-message {
    font-size: 14px;
    color: #d9534f;
    margin-bottom: 10px;
  }

  /* 기존 테이블 및 상세 정보 창 스타일은 그대로 유지*/
  .table-container {
    max-height: calc(100vh - 370px); /*이 값을 조정하여 테이블 높이를 늘립니다.*/
    overflow-y: auto;
    overflow-x: auto;
    border: 1px solid #ddd;
  }
  table {
    border-collapse: collapse;
    width: 100%;
    font-size: 12px;
  }
  th, td {
    padding: 4px 6px;
    text-align: center;
    border: 1px solid #ccc;
    word-wrap: break-word;
  }
  thead {
    background-color: #f0f0f0;
    position: sticky;
    top: 0;
  }
  table thead th {
    color: #000000;
    background-color: #cfcfca;
  }
  tr:nth-child(even) {
    background-color: #fafafa;
  }
  tr:hover {
    background-color: #eef;
  }
  .dialog-backdrop {
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background: rgba(0,0,0,0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .dialog-content {
    background: #fcfcf8;
    padding: 24px;
    border-radius: 10px;
    min-width: 420px;
    max-width: 640px;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 6px 24px rgba(0,0,0,0.4);
    font-size: 1.6rem;
    color:#5e5e4a;
  }
  .dialog-content table {
    width: 100%;
    margin-bottom: 16px;
    font-size: 1rem;
  }
  .dialog-content td {
    padding: 4px;
    font-size: 1rem;
  }
  .dialog-content h3 {
    font-size: 1.4rem;
    margin-bottom: 16px;
    color:#5e5e4a;
    font-weight: bold;;
  }
  .dialog-content .small-btn {
    width: 60px !important;
    min-width: 60px !important;
    padding: 4px 6px !important;
  }
  /* 모바일 대응 */
  @media (max-width: 768px) {
    .dialog-content {
      min-width: auto;
      max-width: 90vw;
      padding: 16px;
      font-size: 1.2rem;
    }
    .dialog-content table {
      font-size: 0.95rem;
    }
    .dialog-content td {
      font-size: 0.95rem;
      padding: 4px;
    }
    .dialog-content h3 {
      font-size: 1.2rem;
      margin-bottom: 12px;
    }
  }
</style>